import { render, staticRenderFns } from "./LineItems.vue?vue&type=template&id=3e566780&scoped=true&"
import script from "./LineItems.vue?vue&type=script&lang=js&"
export * from "./LineItems.vue?vue&type=script&lang=js&"
import style0 from "./LineItems.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LineItems.vue?vue&type=style&index=1&id=3e566780&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e566780",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VMenu})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e566780')) {
      api.createRecord('3e566780', component.options)
    } else {
      api.reload('3e566780', component.options)
    }
    module.hot.accept("./LineItems.vue?vue&type=template&id=3e566780&scoped=true&", function () {
      api.rerender('3e566780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/templates/invoices/schema/LineItems.vue"
export default component.exports